import Search from './pages/search/search';
import Detail from '@assets/product/detail';

document.addEventListener('DOMContentLoaded', (e) => {
  new Search().init();
  new Detail().init();
});
